<template>
<section class="wind-field-wrapper">
  <canvas ref="canvas" />
</section>
</template>

<script>
import * as EventKeyMap from '../Map/EventKeys'
import WindFieldUtil from './WindFieldUtil'

export default {
  name: 'WindField',
  props: {
    data: {
      required: true,
      validator: data => data === null || Array.isArray(data)
    },
    isSatelliteMode: {
      type: Boolean
    }
  },
  methods: {
    setCanvasSize () {
      let canvas = this.getCanvas()
      let {parentNode} = canvas

      canvas.width = parentNode.offsetWidth
      canvas.height = parentNode.offsetHeight

      return canvas
    },
    draw () {
      clearTimeout(this.timer)

      let {map, data} = this

      if (!map || !data) {
        return
      }

      this.timer = setTimeout(() => {
        let {map, windFieldUtil} = this
        let bounds = map.getBounds()
        let {width, height} = this.getCanvas()

        if (bounds.northeast.lng < bounds.southwest.lng) {
          bounds.northeast.lng += 360
        }

        // bounds, width, height, extent
        windFieldUtil.start([[0, 0], [width, height]], width, height, [[bounds.southwest.lng, bounds.southwest.lat], [bounds.northeast.lng, bounds.northeast.lat]])
      }, 750)
    },
    clear () {
      clearTimeout(this.timer)
      this.windFieldUtil.stop()
      let canvas = this.getCanvas()
      let ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)
    },
    onMapZoomEnd () {
      this.windFieldUtil.stop()
      clearTimeout(this.timer)
      this.draw()
    },
    onMapMoveStart () {
      this.clear()
    },
    onMapMoveEnd () {
      this.draw()
    },
    onMapCreated (map) {
      this.map = map

      let {$eventBus} = this
      $eventBus.on(EventKeyMap.MAP_ZOOM_END, this.onMapZoomEnd)
      $eventBus.on(EventKeyMap.MAP_MOVE_START, this.onMapMoveStart)
      $eventBus.on(EventKeyMap.MAP_MOVE_END, this.onMapMoveEnd)
      this.draw()
    },
    onWindowResize () {
      clearTimeout(this.windowResizeTimer)

      this.clear()

      setTimeout(() => {
        this.setCanvasSize()
        this.draw()
      }, 300)
    },
    getCanvas () {
      return this.$refs.canvas
    }
  },
  watch: {
    data: {
      immediate: true,
      handler (data) {
        if (data) {
          this.windFieldUtil.update(data)
          this.clear()
          this.draw()
        }
      }
    },
    isSatelliteMode (isSatelliteMode) {
      this.param.isSatelliteMode = isSatelliteMode
    }
  },
  created () {
    window.addEventListener('resize', this.onWindowResize)
    this.$eventBus.once(EventKeyMap.MAP_CREATED, this.onMapCreated)
  },
  mounted () {
    this.param = {
      data: this.data,
      isSatelliteMode: this.isSatelliteMode
    }
    setTimeout(() => {
      this.param.canvas = this.setCanvasSize()
      this.windFieldUtil = WindFieldUtil(this.param)
      this.draw()
    }, 0)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize)

    let {$eventBus} = this
    $eventBus.off(EventKeyMap.MAP_ZOOM_END, this.onMapZoomEnd)
    $eventBus.off(EventKeyMap.MAP_MOVE_START, this.onMapMoveStart)
    $eventBus.off(EventKeyMap.MAP_MOVE_END, this.onMapMoveEnd)
    this.windFieldUtil.stop()
    clearTimeout(this.timer)
  }
}
</script>

<style lang="scss">
.wind-field-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/WindField/index.vue